<account-page title="Orders">
   @if (tableEntities) {
       <div>
           <vip-paginator
               [paginator]="ordersService.paginator"
               (pageChanged)="setPaginator($event)"
               [requesting]="ordersService.loading"
           ></vip-paginator>
           <cdk-table-component
               [displayColumns]="displayColumns"
               [entities]="tableEntities"
               [dataSource]="dataSource"
               (rowClickAction)="gotToOrder($event)"
           ></cdk-table-component>
       </div>
   }
</account-page>
